import { render, staticRenderFns } from "./ProductivitySummaryByAssociate.vue?vue&type=template&id=134de6b1&"
import script from "./ProductivitySummaryByAssociate.vue?vue&type=script&lang=js&"
export * from "./ProductivitySummaryByAssociate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports